import { useScaPaymentDetailsContext } from '../../contexts/ScaPaymentDetailsContext/ScaPaymentDetailsContext';
import type { ScaApiPaymentDetailsContextData } from '../../contexts/ScaPaymentDetailsContext/ScaPaymentDetailsContext.types';

export const useScaPaymentDetails = (): ScaApiPaymentDetailsContextData => {
  const context = useScaPaymentDetailsContext();

  if (!context.paymentDetails && !context.isFetching && !context.isError) {
    throw new Error(
      'useScaPaymentDetails hook must be used within a <ScaPaymentDetailsContextProvider>'
    );
  }

  return context;
};
